import { render, staticRenderFns } from "./EventMapping.vue?vue&type=template&id=8363734a&"
import script from "./EventMapping.vue?vue&type=script&lang=ts&"
export * from "./EventMapping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports